import { render, staticRenderFns } from "./WidgetSalary.vue?vue&type=template&id=34da3395&"
import script from "./WidgetSalary.vue?vue&type=script&lang=js&"
export * from "./WidgetSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports